import get from'./get.js';import set from'./set.js';/**
 * Get only the given keys from the given object
 */
function only(object, keys) {
    const newObject = {};
    for (const key of keys) {
        const value = get(object, key, undefined);
        if (value !== undefined) {
            set(newObject, key, value);
        }
    }
    return newObject;
}export{only as default};